import React from 'react';
import ReactMarkdown from 'react-markdown';
import breaks from 'remark-breaks';

import Image from '../core/image.js';

const InlineImage = ({ data }) => {
  const { imageType, image, showCaption, caption } = data;

  let imgType;
  switch (imageType) {
    case 'Full Width':
      imgType = 'x py05';
      break;
    case 'Sidebar Large':
      imgType = 'right article__image_side large';
      break;
    case 'Sidebar Largest':
      imgType = 'right article__image_side largest';
      break;
    case 'Sidebar Small':
      imgType = 'right article__image_side small';
      break;
    case 'Inline':
      imgType = 'container--xl p1 ma';
      break;
    default:
      imgType = 'x';
      break;
  }

  return (
    <div key={Math.random()} className={`article__image ac ${imgType}`}>
      {image.fields && <Image source={image.fields.file.url} alt="" />}
      {showCaption === 'no' ? (
        <span />
      ) : (
        <span className="small inline-block p05">
          {caption ? (
            <ReactMarkdown className="" plugins={[breaks]} source={caption} />
          ) : (
            image.fields && image.fields.title
          )}
        </span>
      )}
    </div>
  );
};

export default InlineImage;
